import { useMutation, useQuery } from '@tanstack/react-query';
import type { BodyType } from '../../axios';
import { request } from '../../axios';
import { PreventiveTherapyCompletionReasonEnums, PreventiveTherapyTypeEnums } from '../../../enums/contact-tracing';

// export type TbiTherapyEnums = 'YES' | 'NO';



export interface PreventiveTherapyDto {
    id: string;
    patientId: string;
    referralDate?: string | null;
    followUpDate?: string | null;
    tbiTherapy?: string | null;
    therapyTypes?: PreventiveTherapyTypeEnums[] | null;
    therapyStartDate?: string | null;
    therapyEndDate?: string | null;
    completionReason?: PreventiveTherapyCompletionReasonEnums | null;
    hinweis?: string | null;
}

export const getTracingContactPreventiveTherapyQueryKey = (id: string) =>
    ['tracing-contact-preventive-therapy', id] as const;

export const getTracingContactPreventiveTherapy = (
    id: string,
    signal?: AbortSignal,
) => {
    return request<PreventiveTherapyDto>({
        url: `/api/contact-tracing/tracing-contact/${id}/preventive-therapy`,
        method: 'GET',
        signal,
    });
};

export const useGetTracingContactPreventiveTherapy = (id: string) => {
    return useQuery({
        queryKey: getTracingContactPreventiveTherapyQueryKey(id),
        queryFn: ({ signal }) => getTracingContactPreventiveTherapy(id, signal),
        enabled: !!id,
    });
};

export const updateTracingContactPreventiveTherapy = (
    id: string,
    data: BodyType<PreventiveTherapyDto>,
) => {
    return request<PreventiveTherapyDto>({
        url: `/api/contact-tracing/tracing-contact/${id}/preventive-therapy`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data,
    });
};

export const useUpdateTracingContactPreventiveTherapy = () => {
    return useMutation({
        mutationKey: ['updateTracingContactPreventiveTherapy'],
        mutationFn: ({
            id,
            data,
        }: {
            id: string;
            data: BodyType<PreventiveTherapyDto>;
        }) => updateTracingContactPreventiveTherapy(id, data),
    });
};
